import { api } from '../../../api/common/instances';
import { pick } from 'lodash';

const state = () => ({
  userTargetSystems: [],
  configInfos: null,
  trxnTaskTypes: null,
  sapMemory: null,
  sapBuffer: null,
  queueType: null,
  wProcessType: null,
  wProcessStatus: null,
  stack: null,
  // Added.by.KWShin.2022.10.14.
  isPcapOs: null,
});

const getters = {
  getIdTypes: state => {
    return state.userTargetSystems.map(el => pick(el, ['id', 'stackType']));
  },
  getTaskTypes: state => state.trxnTaskTypes,
};

const mutations = {
  setTargetSystems(state, systems) {
    state.userTargetSystems = systems;
  },
  setconfigs(state, configs) {
    state.configInfos = configs;
  },
  setTaskTypes(state, types) {
    state.trxnTaskTypes = types;
  },
  setSapMemories(state, memories) {
    state.sapMemory = memories;
  },
  setSapBuffers(state, buffers) {
    state.sapBuffer = buffers;
  },
  setQueueTypes(state, queue) {
    state.queueType = queue;
  },
  setWorkProcessTypes(state, queue) {
    state.wProcessType = queue;
  },
  setWorkProcessStatus(state, queue) {
    state.wProcessStatus = queue;
  },
  setSelectStack(state, stack) {
    state.stack = stack;
  },
  // BEGIN::Added.by.KWShin.2022.10.14.
  setPcapOs(state, isPcap) {
    state.isPcapOs = isPcap;
  },
  // FINISH::Added.by.KWShin.2022.10.14.
};

const actions = {
  async targetSystems({ commit }) {
    const { data } = await api.get('/user/target-systems');
    commit('setTargetSystems', data);
  },
  async configs({ commit }) {
    const { data } = await api.get('/statistics/configs');
    commit('setconfigs', data);
  },
  async taskTypes({ commit }) {
    const { data } = await api.get('/statistics/task-types');
    commit('setTaskTypes', data);
  },
  async sapMemories({ commit }) {
    const { data } = await api.get('/statistics/sap-memories');
    commit('setSapMemories', data);
  },
  async sapBuffers({ commit }) {
    const { data } = await api.get('/statistics/sap-buffers');
    commit('setSapBuffers', data);
  },
  async queueTypes({ commit }) {
    const { data } = await api.get('/statistics/queue-types');
    commit('setQueueTypes', data);
  },
  async workProcessTypes({ commit }) {
    const { data } = await api.get('/statistics/work-process-types');
    commit('setWorkProcessTypes', data);
  },
  async workProcessStatus({ commit }) {
    const { data } = await api.get('/statistics/work-process-status');
    commit('setWorkProcessStatus', data);
  },
  setSelectStack({ commit }, stack) {
    commit('setSelectStack', stack);
  },
  async isPcapOs({ commit }) {
    // BEGIN::Added.by.KWShin.2022.10.14.
    const { data } = await api.get('/prefer/is-collecting-pcap-os');
    commit('setPcapOs', data);
  },
  // FINISH::Added.by.KWShin.2022.10.14.
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
